// Import necessary modules
import { ZodError } from 'zod';

export const validateAgainstSchema = (schema: any, body: any, silent: boolean = false) => {
    try {
        let parseResponse = schema.parse(body);
        // silent ? null : console.log("✅  Success ", parseResponse);
        return parseResponse;
    } catch (error: unknown) {
        if (error instanceof ZodError) {
            error.errors.forEach(error => {
                silent ? null : console.log("⚠️  Zod error : ", error.message);
            });
        }
        return error;
    }
};

export const convertToTitleCase = (inputString: string) => {
    return inputString
        .split('.')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
};
